import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { verbs } from './verbs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ws-teform';

  constructor(private toastr: ToastrService) {
    this.nextVerb();
  }

  verbs = verbs;
  currentVerb = null;
  answer = { text: '' };

  nextVerb() {
    this.currentVerb = verbs[Math.floor((Math.random()*verbs.length))];
  }

  submitAnswer() {
    let correctAnswer = this.getCorrectAnswer();
    if (this.answer.text != correctAnswer) {
      this.toastr.error(correctAnswer, 'ちがいます!', {
        disableTimeOut: true,
        closeButton: true        
      });
    }
    else {
      this.toastr.success('せいかいです!');

      this.answer.text = '';
      this.nextVerb();
    }
  }

  getCorrectAnswer() {
    let stem = this.currentVerb.text.substring(0, this.currentVerb.text.length - 2);
    console.log('verb stem: ' + stem);

    if (this.currentVerb.group == 2) {
      let lastChar = stem.substring(stem.length - 1);
      
      if (['い', 'ち', 'り'].indexOf(lastChar) > -1) {
        return stem.substring(0, stem.length - 1) + 'って';
      }
      else if (['に', 'み', 'び'].indexOf(lastChar) > -1) {
        return stem.substring(0, stem.length - 1) + 'んで';
      }
      else if (lastChar == 'き') {
        return stem.substring(0, stem.length - 1) + 'いて';
      }
      else if (lastChar == 'ぎ') {
        return stem.substring(0, stem.length - 1) + 'いで';
      }
      else {
        console.error('Unrecognised group 1 ending: ' + lastChar);
        return stem + 'て';
      }
    }
    else {
      // group 1 or 3 - chop off masu, add te
      return stem + 'て';
    }
  }
}
